import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import history from 'utils/history';

import { Row, Col, Button, Label, FormGroup, SheetBody, SheetFooter, FormSection } from 'twyne-new.ui'
import Input from 'components/form/Input';
import Switch from 'components/form/Switch';
import Select from 'components/form/Select';

class RetargetingForm extends React.Component {
  state = {
    type: '',
    meta: {}
  };

  typeOptions = [
    { value: 'circulate', label: 'Circulate' },
    { value: 'criteo', label: 'Criteo' },
    { value: 'traverse', label: 'Traverse' },
    { value: 'liveramp', label: 'Liveramp' },
    { value: 'sovrn', label: 'Sovrn' },
    { value: 'neustar', label: 'Neustar' }
  ]

  componentWillMount () {
    const data = this.props.data;
    if (data) {
      this.setState(data);
    }
  }

  handleOnChangeType = (option) => {
    let updateState = this.state;
    updateState.type = option ? option.value : '';
    this.setState(updateState);
  }
  
  handleValidSubmit = (model) => {
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  render () {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="6">
              <FormGroup>
                <Label>Retargeting Placement Name</Label>
                <Input name="name" value={this.state.name || ''} required />
              </FormGroup>
            </Col>
            <Col size="5">
              <FormGroup>
                <Label>Type</Label>
                <Select name="type" value={this.state.type} options={this.typeOptions}
                  handleOnChange={this.handleOnChangeType} required />
              </FormGroup>
            </Col>
            <Col size="1">
              <FormGroup>
                <Label>Active</Label>
                <Switch name="active" value={this.state.active || false} />
              </FormGroup>
            </Col>
          </Row>
          {this.state.type && <>
            <FormSection className='mt-4'>Meta</FormSection>
            {this.renderMeta()}
          </>}
        </SheetBody>
        <SheetFooter>
          <Button onClick={() => history.goBack()} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }

  renderMeta() {
    if (this.state.type === 'circulate') {
      return this.renderMetaCirculate();
    } else if (this.state.type === 'traverse') {
      return this.renderMetaTraverse();
    } else if (this.state.type === 'criteo') {
      return this.renderMetaCriteo();
    } else if (this.state.type === 'liveramp') {
      return this.renderMetaLiveramp();
    } else if (this.state.type === 'sovrn') {
      return this.renderMetaSovrn();
    } else if (this.state.type === 'neustar') {
      return this.renderMetaNeustar();
    }
    return null;
  }

  renderMetaSovrn() {
    return (
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Sovrn ID</Label>
            <Input name="meta.siteId" value={this.state.meta.siteId || ''}/>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  renderMetaLiveramp() {
    return (
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Liveramp ID</Label>
            <Input name="meta.siteId" value={this.state.meta.siteId || ''}/>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  renderMetaCirculate() {
    return (
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Circulate Site ID</Label>
            <Input name="meta.siteId" value={this.state.meta.siteId || ''}/>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  renderMetaTraverse() {
    return (
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Client ID</Label>
            <Input name="meta.clientID" value={this.state.meta.clientID || ''}/>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  renderMetaCriteo() {
    return (
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Tracker Domain Name</Label>
            <Input name="meta.domainName" value={this.state.meta.domainName  || ''}/>
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>ID Base</Label>
            <Input name="meta.idBase" value={this.state.meta.idBase  || ''}/>
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Safety Key</Label>
            <Input name="meta.safetyKey" value={this.state.meta.safetyKey  || ''}/>
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Use SSL</Label>
            <Switch name="meta.useSsl" value={this.state.meta.useSsl || ''}/>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  renderMetaNeustar() {
    return <Row>
      <Col size="6">
        <FormGroup>
          <Label>Neustar ID</Label>
          <Input name="meta.sid" value={this.state.meta.sid || ''}/>
        </FormGroup>
      </Col>
    </Row>
  }
}

RetargetingForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

export default RetargetingForm;
